import type {Values} from "@wix/devzai-utils-common";
import {VideoServices, videoServicesResolveVideoSource} from "@wix/devzai-utils-common";
import type {WixVideoResource} from "@wix/devzai-common-wix";
import {wixVideoInfoGetVideoUrl, WixVideoInfoQualitySelector} from "@wix/devzai-common-wix";

export const DoppeBymoPageVideoServices = {
    ...VideoServices,
    Wix: 'Wix'
} as const;

export type DoppeBymoPageVideoServices = Values<typeof DoppeBymoPageVideoServices>;

export type DoppeBymoPageVideoSource = string | WixVideoResource;

export function doppeBymoPageVideoSourceResolveVideoUrl (videoSource: DoppeBymoPageVideoSource) {
    if (typeof videoSource === 'string') {
        return videoSource;
    } else {
        return wixVideoInfoGetVideoUrl(videoSource, {
            qualitySelector: WixVideoInfoQualitySelector.Highest
        })
    }
}

export function doppeBymoPageVideoSourceResolveVideoService (videoSource: DoppeBymoPageVideoSource) : DoppeBymoPageVideoServices | null {
    return typeof videoSource === 'string' ? (videoServicesResolveVideoSource(videoSource)?.videoService ?? null) : DoppeBymoPageVideoServices.Wix;
}

export function doppeBymoPageVideoSourceGetPoster (videoSource: DoppeBymoPageVideoSource) {
    return typeof videoSource !== 'string' ? (videoSource.poster ?? null) : null;
}